const styles = {
    paddingX: "sm:px-16 px-6",
    paddingY: "sm:py-16 py-6",
    padding: "sm:px-16 px-6 sm:py-16 py-10",
  
    heroHeadText:
      "font-black text-foreground xl:text-[60px] lg:text-[50px] md:text-[45px] sm:text-[40px] xs:text-[40px] text-[28px] lg:leading-[100px] md:leading-[65px] mt-2",
    heroSubText:
      "text-foreground-muted font-medium lg:text-[30px] md:text-[25px] sm:text-[20px] xs:text-[20px] text-[18px] lg:leading-[50px] md:leading-[40px]",
  
    sectionHeadText:
      "text-foreground font-black md:text-[45px] sm:text-[35px] xs:text-[30px] text-[25px]",
    sectionSubText:
      "sm:text-[16px] text-[14px] text-secondary uppercase tracking-wider gradient-heading",

    contactText: "text-foreground font-medium sm:text-[15px] text-[14px]",
  };
  
  export { styles };